import moment from "moment";

// export const FormatSalaryItem = (item, index) => ({});

export const FormatSalaryItem = (data, pageNumber, limit) => {
  return data.map((item, index) => ({
    no: (pageNumber - 1) * limit + index + 1,
    id: item.id || "-",
    projectId: item.project_id || "-",
    sourceProject: item.source_project || "-",
    clientName: item.client_name || "-",
    workerId: item.worker_id || "-",
    workerName: item.worker_name || "-",
    workerType: item.worker_type || "-",
    skillId: item.skill_id || "-",
    skillName: item.skill_name || "-",
    attendanceDate: item.attendance_date ? moment(item.attendance_date).format("YYYY-MM-DD") : "-",
    sesi: item.sesi || 0,
    workerOnsite: item.worker_onsite || 0,
    workerOrder: item.worker_order || 0,
    order: item.order || 0,
    orderSukses: item.order_sukses || 0,
    upahHarian: item.upah_harian || 0,
    upahInsentif: item.upah_insentif || 0,
    upahTransport: item.upah_transport || 0,
    upahKeramik: item.upah_keramik || 0,
    upahLas: item.upah_las || 0,
    feeBuilding: item.upah_fee_building || 0,
    totalUpah: item.total_upah || 0,
    insurance: item.insurance || 0,
    consumerAmount: item.consumer_amount || 0,
    vendorAmount: item.vendor_amount || 0,
    contractorAmount: item.contractor_amount || 0,
    finalAmount: Number(item.final_amount) || item.total_amount || 0,
    amount: Number(item.amount) || item.amount || item.original_amount || 0,
    initialAmount: Number(item.initial_amount) || item.initial_amount || item.original_amount || 0,
    deduction: item.deduction || 0,
    complaintAdditional: item.complain_closed || 0,
    complaintDeduction: item.complaint_on_hold || 0,
    kasbonDeduction: item.kasbon || 0,
    cicilanDeduction: item.cicilan || 0,
    bpjsDeduction: item.bpjs || 0,
    depositDeduction: item.topup_deposit || 0,
    feeBank: item.fee_admin_bank || 0,
    totalUnpaid: item.total_unpaid || 0,
    depositBalance: item.deposit_balance || 0,
    isTopup: item.is_topup ?? 0,
    canSwap: item.can_swap ?? false,
    bonus: item.bonus || 0,
    point: item.point || 0,
    totalJobs: item.total_jobs || 0,
    email: item.email || "-",
    bankCode: item.bank_code || "-",
    bankAccount: item.bank_account || "-",
    bankAccountName: item.bank_account_name || "-",
    items: Array.isArray(item.items)
      ? item.items.map((i) => ({
          id: i.id || "-",
          unpaidAmount: i.unpaid_amount || 0,
          shippingCost: i.shipping_cost || 0,
          deductionAmount: i.deduction_amount || 0,
          installmentPhase: i.installment_phase || "-",
          installmentType: i.installment_type || "-",
          status: i.status || "-",
          deductionMark: i.deduction_mark || 0,
        }))
      : [],
    isPosting: item.is_posting ?? 0,
    isModif: item.is_modif || "-",
    isBookmark: item.is_bookmark ?? 0,
    notes: item.keterangan || "-",
    createdAt: item.created_at ? moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    updatedAt: item.updated_at ? moment(item.updated_at).format("YYYY-MM-DD HH:mm:ss") : "-",
  }));
};
